import { default as React } from 'react'
import { LoadingButton } from '@mui/lab';
import CancelIcon from '@mui/icons-material/Close'

export default function HelpCommandBar (props = {}) {
  return (
    <div className="tis-commandbar tis-commandbar-help">
      {(props.showCancel === undefined || props.showCancel) && <LoadingButton loading={props.loading} variant="outlined" onClick={props.onCancel} endIcon={<CancelIcon />}>Close</LoadingButton>}
    </div>
  )
}
